<template>
  <v-app class="page">

    <!-- =========================================================
         MAIN
    ========================================================== -->

    <v-main>

      <!-- =======================================================
           HERO
      ======================================================== -->

      <section class="hero">

        <!-- Hintergrund -->
        <img
          :src="kitchen"
          alt=""
          class="hero-background"
        />

        <!-- dunkler Verlauf -->
        <div class="hero-overlay"></div>

        <div class="hero-inner">

          <!-- =================================================
               LINKER HERO-BEREICH
          ================================================== -->

          <div class="hero-left">

            <div class="hero-eyebrow">
              HYGIENE, DIE IM
            </div>

            <h1 class="hero-title">

              <span>
                ALLTAG FUNKTIONIERT.
              </span>

              NICHT NUR AUF DEM PAPIER.

            </h1>

            <div class="hero-line"></div>

            <p class="hero-text">
              TR-Hygieneprofis steht für praxisnahe Hygienberatung,
              Schulungen und Konzepte, die zu Ihrem Betrieb passen –
              verständlich, umsetzbar und wirksam.
            </p>


            <!-- =================================================
                 HERO MERKMALE
            ================================================== -->

            <div class="hero-features">

              <!-- 1 -->

              <div class="hero-feature">

                <div class="hero-feature-icon">

                  <v-icon size="38">
                    mdi-shield-check-outline
                  </v-icon>

                </div>

                <div class="hero-feature-title">
                  PRAXISNAH
                </div>

                <div class="hero-feature-text">
                  Lösungen, die im
                  Alltag funktionieren.
                </div>

              </div>


              <!-- 2 -->

              <div class="hero-feature">

                <div class="hero-feature-icon">

                  <v-icon size="38">
                    mdi-target
                  </v-icon>

                </div>

                <div class="hero-feature-title">
                  ZIELGERICHTET
                </div>

                <div class="hero-feature-text">
                  Effiziente Konzepte
                  statt Standardlösungen.
                </div>

              </div>


              <!-- 3 -->

              <div class="hero-feature">

                <div class="hero-feature-icon">

                  <v-icon size="38">
                    mdi-account-group-outline
                  </v-icon>

                </div>

                <div class="hero-feature-title">
                  ERFAHREN
                </div>

                <div class="hero-feature-text">
                  Langjährige Praxis in
                  unterschiedlichen
                  Betrieben.
                </div>

              </div>


              <!-- 4 -->

              <div class="hero-feature">

                <div class="hero-feature-icon">

                  <v-icon size="38">
                    mdi-handshake-outline
                  </v-icon>

                </div>

                <div class="hero-feature-title">
                  PARTNERSCHAFTLICH
                </div>

                <div class="hero-feature-text">
                  Auf Augenhöhe.
                  Verlässlich. Ehrlich.
                </div>

              </div>

            </div>

          </div>


          <!-- =================================================
               PERSON RECHTS
          ================================================== -->

          <div class="hero-person">

            <img
              :src="Ruben"
              alt="Ruben Rohletter"
              class="person-image"
            />

          </div>

        </div>

      </section>


      <!-- =======================================================
           LEISTUNGEN
      ======================================================== -->

      <section
        id="leistungen"
        class="services-section"
      >

        <div class="page-container">

          <!-- Überschrift -->

          <div class="section-heading">

            <h2>
              UNSERE LEISTUNGEN
            </h2>

            <div class="heading-line"></div>

            <p>
              Ganzheitliche Hygienberatung und Schulungen für sichere Prozesse,<br />
              zufriedene Kunden und nachhaltigen Unternehmenserfolg.
            </p>

          </div>


          <!-- Leistungskarten -->

          <div class="services-grid">

            <!-- 1 -->

            <div class="service-card">

              <v-icon
                class="service-icon"
                size="45"
              >
                mdi-clipboard-check-outline
              </v-icon>

              <h3>
                Hygienekonzepte
              </h3>

              <p>
                Erstellung und Optimierung
                individueller Hygienekonzepte
                nach aktuellen Vorgaben.
              </p>

            </div>


            <!-- 2 -->

            <div class="service-card">

              <v-icon
                class="service-icon"
                size="45"
              >
                mdi-shield-check-outline
              </v-icon>

              <h3>
                HACCP &<br />
                Eigenkontrollsysteme
              </h3>

              <p>
                Aufbau, Überprüfung und
                Weiterentwicklung wirksamer
                HACCP-Systeme.
              </p>

            </div>


            <!-- 3 -->

            <div class="service-card">

              <v-icon
                class="service-icon"
                size="45"
              >
                mdi-account-school-outline
              </v-icon>

              <h3>
                Schulungen &<br />
                Unterweisungen
              </h3>

              <p>
                Praxisnahe Schulungen –
                vor Ort, online oder inhouse
                für Ihr Team.
              </p>

            </div>


            <!-- 4 -->

            <div class="service-card">

              <v-icon
                class="service-icon"
                size="45"
              >
                mdi-spray-bottle
              </v-icon>

              <h3>
                Reinigungs- &<br />
                Desinfektionspläne
              </h3>

              <p>
                Hygienisch sichere Reinigungs-
                und Desinfektionspläne,
                die funktionieren.
              </p>

            </div>


            <!-- 5 -->

            <div class="service-card">

              <v-icon
                class="service-icon"
                size="45"
              >
                mdi-account-group-outline
              </v-icon>

              <h3>
                Allergenmanagement
              </h3>

              <p>
                Sichere Prozesse im Umgang
                mit Allergenen – von der
                Kennzeichnung bis zur Schulung.
              </p>

            </div>


            <!-- 6 -->

            <div class="service-card">

              <v-icon
                class="service-icon"
                size="45"
              >
                mdi-cube-outline
              </v-icon>

              <h3>
                Lebensmittelsicherheit
              </h3>

              <p>
                Umsetzung gesetzlicher
                Anforderungen für sichere
                Lebensmittelprozesse.
              </p>

            </div>


            <!-- 7 -->

            <div class="service-card">

              <v-icon
                class="service-icon"
                size="45"
              >
                mdi-bacteria-outline
              </v-icon>

              <h3>
                Listerienkonzepte
              </h3>

              <p>
                Risikobewertung, Monitoring
                und Maßnahmen zur Kontrolle
                von Listerien.
              </p>

            </div>


            <!-- 8 -->

            <div class="service-card">

              <v-icon
                class="service-icon"
                size="45"
              >
                mdi-alert-outline
              </v-icon>

              <h3>
                Havarie- &<br />
                Krisenpläne
              </h3>

              <p>
                Für den Ernstfall vorbereitet –
                individuelle Pläne und klare
                Abläufe.
              </p>

            </div>


            <!-- 9 -->

            <div class="service-card">

              <v-icon
                class="service-icon"
                size="45"
              >
                mdi-water-outline
              </v-icon>

              <h3>
                Legionellenmanagement
              </h3>

              <p>
                Beurteilung, Dokumentation
                und Maßnahmen für sichere
                Trinkwasserinstallationen.
              </p>

            </div>


            <!-- 10 -->

            <div class="service-card">

              <v-icon
                class="service-icon"
                size="45"
              >
                mdi-clipboard-text-outline
              </v-icon>

              <h3>
                Dokumentation &<br />
                Auditvorbereitung
              </h3>

              <p>
                Rechtssichere Dokumentation
                und Vorbereitung auf Audits
                und Kontrollen.
              </p>

            </div>


            <!-- 11 -->

            <div class="service-card">

              <v-icon
                class="service-icon"
                size="45"
              >
                mdi-map-marker-outline
              </v-icon>

              <h3>
                Beratung vor Ort
              </h3>

              <p>
                Persönliche Unterstützung
                in Ihrem Betrieb – praxisnah
                und lösungsorientiert.
              </p>

            </div>


            <!-- 12 -->

            <div class="service-card">

              <v-icon
                class="service-icon"
                size="45"
              >
                mdi-file-document-outline
              </v-icon>

              <h3>
                IfSG &<br />
                Lebensmittelrecht
              </h3>

              <p>
                Beratung zu gesetzlichen
                Vorgaben und deren sicherer
                Umsetzung im Betrieb.
              </p>

            </div>

          </div>

        </div>

      </section>


      <!-- =======================================================
           BRANCHEN
      ======================================================== -->

      <section
        id="branchen"
        class="branches-section"
      >

        <div class="page-container">

          <div class="dark-section-heading">

            <h2>
              FÜR WELCHE BRANCHEN WIR DA SIND
            </h2>

            <div class="heading-line"></div>

          </div>


          <div class="branches-grid">

            <!-- 1 -->

            <div class="branch">

              <v-icon size="40">
                mdi-account-group-outline
              </v-icon>

              <span>
                Gemeinschafts-<br />
                verpflegung
              </span>

            </div>


            <!-- 2 -->

            <div class="branch">

              <v-icon size="40">
                mdi-silverware-fork-knife
              </v-icon>

              <span>
                Gastronomie
              </span>

            </div>


            <!-- 3 -->

            <div class="branch">

              <v-icon size="40">
                mdi-food-steak
              </v-icon>

              <span>
                Fleischereien &<br />
                Metzgereien
              </span>

            </div>


            <!-- 4 -->

            <div class="branch">

              <v-icon size="40">
                mdi-package-variant-closed
              </v-icon>

              <span>
                Lebensmittel-<br />
                produktion
              </span>

            </div>


            <!-- 5 -->

            <div class="branch">

              <v-icon size="40">
                mdi-home-group
              </v-icon>

              <span>
                Kitas &<br />
                Schulen
              </span>

            </div>


            <!-- 6 -->

            <div class="branch">

              <v-icon size="40">
                mdi-account-multiple
              </v-icon>

              <span>
                Pflege &<br />
                Soziale Einrichtungen
              </span>

            </div>


            <!-- 7 -->

            <div class="branch">

              <v-icon size="40">
                mdi-broom
              </v-icon>

              <span>
                Gebäudereinigung &<br />
                Dienstleister
              </span>

            </div>

          </div>

        </div>

      </section>


      <!-- =======================================================
           WARUM TR-HYGIENEPROFIS
      ======================================================== -->

      <section
        id="wissen"
        class="why-section"
      >

        <div class="page-container">

          <div class="why-box">

            <!-- LINKER BEREICH -->

            <div class="why-left">

              <h2>
                WARUM TR-HYGIENEPROFIS?
              </h2>

              <div class="small-green-line"></div>

              <p>
                Wir verbinden fundiertes Fachwissen mit echter
                Praxiserfahrung. Unsere Konzepte sind verständlich,
                umsetzbar und auf Ihren Betrieb zugeschnitten.
                So schaffen wir mehr Sicherheit für Gäste, Kunden
                und Mitarbeitende – und entlasten Sie im Alltag.
              </p>

            </div>


            <!-- TRENNLINIE -->

            <div class="why-divider"></div>


            <!-- RECHTER BEREICH -->

            <div class="why-right">

              <div class="why-item">

                <v-icon size="19">
                  mdi-check-circle-outline
                </v-icon>

                <span>
                  Verständliche Konzepte statt komplizierter Theorie
                </span>

              </div>


              <div class="why-item">

                <v-icon size="19">
                  mdi-check-circle-outline
                </v-icon>

                <span>
                  Pragmatische Lösungen, die wirklich greifen
                </span>

              </div>


              <div class="why-item">

                <v-icon size="19">
                  mdi-check-circle-outline
                </v-icon>

                <span>
                  Sicherheit bei Kontrollen und Audits
                </span>

              </div>


              <div class="why-item">

                <v-icon size="19">
                  mdi-check-circle-outline
                </v-icon>

                <span>
                  Partnerschaftliche Zusammenarbeit auf Augenhöhe
                </span>

              </div>

            </div>

          </div>

        </div>

      </section>


      <!-- =======================================================
           CTA
      ======================================================== -->

      <section
        id="kontakt"
        class="cta-section"
      >

        <div class="cta-pattern"></div>

        <div class="page-container">

          <div class="cta-inner">

            <!-- SCHILD -->

            <div class="cta-shield">

              <v-icon size="82">
                mdi-shield-outline
              </v-icon>

              <v-icon
                size="38"
                class="shield-check"
              >
                mdi-check
              </v-icon>

            </div>


            <!-- TEXT -->

            <div class="cta-content">

              <h2>
                BEREIT FÜR<br />

                MEHR

                <span>
                  SICHERHEIT?
                </span>
              </h2>

              <p>
                Lassen Sie uns gemeinsam Ihre Hygiene
                auf das nächste Level bringen.
              </p>

            </div>


            <!-- BUTTON -->

            <a
              href="#kontakt"
              class="cta-button"
            >

              <span>
                Jetzt Beratung anfragen
              </span>

              <v-icon size="18">
                mdi-chevron-right
              </v-icon>

            </a>

          </div>

        </div>

      </section>

    </v-main>

  </v-app>
</template>


<script setup>

/*
 * Das freigestellte Ruben-Bild.
 *
 * Wichtig:
 * Die PNG-Datei muss einen transparenten Hintergrund besitzen.
 */
import Ruben from '../assets/AvatarRuben.png'

/*
 * Hintergrundbild des Hero-Bereichs.
 */
import kitchen from '../assets/backgroundKitchen.png'

</script>


<style scoped>

/* ============================================================
   GRUNDLEGEND
============================================================ */

:global(*) {
  box-sizing: border-box;
}

:global(html) {
  scroll-behavior: smooth;
}

:global(body) {
  margin: 0;
  padding: 0;

  font-family:
    Arial,
    Helvetica,
    sans-serif;

  background: #ffffff;

  color: #111111;
}

:global(a) {
  -webkit-tap-highlight-color: transparent;
}

.page {
  --green: #78be20;
  --dark: #090909;

  background: #ffffff;
}


/* ============================================================
   CONTAINER
============================================================ */

.page-container {
  width: calc(100% - 120px);

  max-width: 1180px;

  margin-left: auto;
  margin-right: auto;
}


/* ============================================================
   HERO
============================================================ */

.hero {
  width: 100%;

  height: 525px;

  position: relative;

  overflow: hidden;

  background: #090909;
}


/* ============================================================
   HERO HINTERGRUNDBILD
============================================================ */

.hero-background {
  position: absolute;

  top: 0;
  right: 0;
  bottom: 0;
  left: auto;

  width: 78%;
  height: 100%;

  object-fit: contain;

  object-position: right center;

  z-index: 0;
}


/* ============================================================
   HERO OVERLAY
============================================================ */

.hero-overlay {
  position: absolute;

  top: 0;
  right: 0;
  bottom: 0;
  left: 0;

  z-index: 1;

  background:
    linear-gradient(
      90deg,
      rgba(5, 5, 5, 0.98) 0%,
      rgba(5, 5, 5, 0.96) 25%,
      rgba(5, 5, 5, 0.82) 43%,
      rgba(5, 5, 5, 0.35) 60%,
      rgba(5, 5, 5, 0.03) 77%,
      rgba(5, 5, 5, 0) 100%
    );
}


/* ============================================================
   HERO INNER
============================================================ */

.hero-inner {
  width: 100%;

  max-width: 1180px;

  height: 525px;

  margin: 0 auto;

  position: relative;

  z-index: 2;
}


/* ============================================================
   HERO LINKER TEXTBEREICH
============================================================ */

.hero-left {
  position: absolute;

  left: 0;

  top: 0;

  width: 58%;

  height: 100%;

  padding-top: 47px;

  z-index: 10;
}


/* ============================================================
   HERO EYEBROW
============================================================ */

.hero-eyebrow {
  color: #ffffff;

  font-size: 27px;

  line-height: 1.1;

  font-weight: 400;

  letter-spacing: 0.2px;
}


/* ============================================================
   HERO TITEL
============================================================ */

.hero-title {
  margin: 0;

  margin-top: 5px;

  padding: 0;

  max-width: 620px;

  font-size: 31px;

  line-height: 1.18;

  font-weight: 400;

  color: #ffffff;
}

.hero-title span {
  display: block;

  color: var(--green);

  font-weight: 600;
}


/* ============================================================
   GRÜNE LINIE
============================================================ */

.hero-line {
  width: 42px;

  height: 2px;

  margin-top: 22px;

  margin-bottom: 20px;

  background: var(--green);
}


/* ============================================================
   HERO BESCHREIBUNG
============================================================ */

.hero-text {
  width: 520px;

  max-width: 100%;

  margin: 0;

  color: #ffffff;

  font-size: 12.5px;

  line-height: 1.7;

  font-weight: 400;
}


/* ============================================================
   HERO FEATURES
============================================================ */

.hero-features {
  width: 100%;

  max-width: 620px;

  margin-top: 29px;

  display: grid;

  grid-template-columns:
    repeat(4, 1fr);

  border-top: 0 solid rgba(255,255,255,0.15);
}


.hero-feature {
  min-height: 102px;

  padding: 0 13px;

  border-right:
    1px solid rgba(255,255,255,0.30);

  text-align: center;

  color: #ffffff;
}


.hero-feature:first-child {
  padding-left: 0;
}


.hero-feature:last-child {
  border-right: none;
}


/* ============================================================
   ICON
============================================================ */

.hero-feature-icon {
  height: 43px;

  margin-bottom: 8px;

  display: flex;

  align-items: center;

  justify-content: center;

  color: var(--green);
}


.hero-feature-icon .v-icon {
  color: var(--green);
}


/* ============================================================
   FEATURE ÜBERSCHRIFT
============================================================ */

.hero-feature-title {
  margin-bottom: 8px;

  color: #ffffff;

  font-size: 9.5px;

  line-height: 1.2;

  font-weight: 700;

  white-space: nowrap;
}


/* ============================================================
   FEATURE BESCHREIBUNG
============================================================ */

.hero-feature-text {
  color: #ffffff;

  font-size: 8.5px;

  line-height: 1.45;
}


/* ============================================================
   HERO PERSON
============================================================ */

.hero-person {
  position: absolute;

  top: 0;

  right: 0;

  width: 48%;

  height: 100%;

  display: flex;

  align-items: flex-end;

  justify-content: flex-end;

  z-index: 5;

  pointer-events: none;
}


.person-image {
  position: absolute;

  right: -4px;

  bottom: -1px;

  width: 100%;

  height: 100%;

  object-fit: contain;

  object-position: bottom right;

  display: block;
}


/* ============================================================
   LEISTUNGEN
============================================================ */

.services-section {
  width: 100%;

  background: #ffffff;

  padding-top: 27px;

  padding-bottom: 30px;
}


/* ============================================================
   SECTION ÜBERSCHRIFT
============================================================ */

.section-heading {
  text-align: center;

  margin-bottom: 22px;
}


.section-heading h2 {
  margin: 0;

  color: #111111;

  font-size: 19px;

  line-height: 1.2;

  font-weight: 600;
}


.heading-line {
  width: 30px;

  height: 2px;

  margin: 9px auto 12px;

  background: var(--green);
}


.section-heading p {
  margin: 0;

  color: #111111;

  font-size: 10.5px;

  line-height: 1.7;
}


/* ============================================================
   SERVICE GRID
============================================================ */

.services-grid {
  display: grid;

  grid-template-columns:
    repeat(4, 1fr);

  gap: 8px;
}


.service-card {
  min-height: 169px;

  padding:
    17px
    18px
    15px;

  background:
    linear-gradient(
      135deg,
      #fafaf8,
      #f6f6f3
    );

  display: flex;

  flex-direction: column;

  align-items: center;

  text-align: center;

  color: #111111;
}


.service-icon {
  margin-bottom: 9px;

  color: var(--green) !important;

  flex-shrink: 0;
}


.service-card h3 {
  margin: 0;

  min-height: 29px;

  color: #111111;

  font-size: 11px;

  line-height: 1.25;

  font-weight: 700;
}


.service-card p {
  max-width: 210px;

  margin:
    11px
    0
    0;

  color: #111111;

  font-size: 9px;

  line-height: 1.6;
}


/* ============================================================
   BRANCHEN
============================================================ */

.branches-section {
  width: 100%;

  background: #090909;

  color: #ffffff;

  padding-top: 20px;

  padding-bottom: 22px;
}


.dark-section-heading {
  text-align: center;

  margin-bottom: 14px;
}


.dark-section-heading h2 {
  margin: 0;

  color: #ffffff;

  font-size: 18px;

  line-height: 1.2;

  font-weight: 500;
}


.dark-section-heading .heading-line {
  margin-bottom: 0;
}


/* ============================================================
   BRANCHEN GRID
============================================================ */

.branches-grid {
  display: grid;

  grid-template-columns:
    repeat(7, 1fr);

  align-items: start;
}


.branch {
  min-height: 76px;

  display: flex;

  flex-direction: column;

  align-items: center;

  justify-content: flex-start;

  text-align: center;

  color: #ffffff;
}


.branch .v-icon {
  color: var(--green);

  margin-bottom: 7px;
}


.branch span {
  color: #ffffff;

  font-size: 8.5px;

  line-height: 1.45;
}


/* ============================================================
   WARUM
============================================================ */

.why-section {
  width: 100%;

  background: #ffffff;

  padding-top: 27px;

  padding-bottom: 20px;
}


.why-box {
  min-height: 142px;

  padding:
    22px
    34px;

  background:
    linear-gradient(
      135deg,
      #f8f8f5,
      #f4f4f0
    );

  display: grid;

  grid-template-columns:
    1fr
    1px
    1.1fr;

  column-gap: 29px;

  align-items: center;
}


/* ============================================================
   WARUM LINKS
============================================================ */

.why-left h2 {
  margin: 0;

  color: #111111;

  font-size: 18px;

  line-height: 1.2;

  font-weight: 600;
}


.small-green-line {
  width: 30px;

  height: 2px;

  margin-top: 8px;

  margin-bottom: 13px;

  background: var(--green);
}


.why-left p {
  max-width: 490px;

  margin: 0;

  color: #111111;

  font-size: 9.5px;

  line-height: 1.75;
}


/* ============================================================
   TRENNLINIE
============================================================ */

.why-divider {
  width: 1px;

  height: 91px;

  background: #deded8;
}


/* ============================================================
   WARUM RECHTS
============================================================ */

.why-right {
  display: flex;

  flex-direction: column;

  gap: 11px;
}


.why-item {
  display: flex;

  align-items: center;

  gap: 10px;

  color: #111111;

  font-size: 10px;

  line-height: 1.3;
}


.why-item .v-icon {
  color: var(--green);
}


/* ============================================================
   CTA
   HIER WURDE DIE FEHLERHAFTE HÖHE KORRIGIERT
============================================================ */

.cta-section {
  width: 100%;

  min-height: 156px;

  height: auto;

  position: relative;

  overflow: hidden;

  background: #090909;

  color: #ffffff;
}


/* ============================================================
   CTA MUSTER
============================================================ */

.cta-pattern {
  position: absolute;

  inset: 0;

  opacity: 0.35;

  background:
    linear-gradient(
      25deg,
      transparent 47%,
      rgba(120,190,32,0.30) 47.2%,
      transparent 47.6%
    ),
    linear-gradient(
      155deg,
      transparent 53%,
      rgba(120,190,32,0.20) 53.2%,
      transparent 53.6%
    );

  pointer-events: none;
}


/* ============================================================
   CTA INNER
============================================================ */

.cta-inner {
  min-height: 156px;

  height: auto;

  position: relative;

  z-index: 2;

  display: flex;

  align-items: center;

  gap: 26px;

  padding: 18px 0;
}


/* ============================================================
   CTA SCHILD
============================================================ */

.cta-shield {
  width: 125px;

  min-width: 125px;

  height: 110px;

  position: relative;

  display: flex;

  align-items: center;

  justify-content: center;

  color: #ffffff;

  flex-shrink: 0;
}


.cta-shield > .v-icon:first-child {
  color: #ffffff;
}


.shield-check {
  position: absolute;

  color: var(--green) !important;

  margin-top: 3px;
}


/* ============================================================
   CTA TEXT
============================================================ */

.cta-content {
  flex: 1 1 auto;

  min-width: 0;

  display: flex;

  flex-direction: column;

  justify-content: center;
}


.cta-content h2 {
  margin: 0;

  color: #ffffff;

  font-size: 22px;

  line-height: 1.05;

  font-weight: 500;
}


.cta-content h2 span {
  color: var(--green);

  font-weight: 600;
}


.cta-content p {
  margin:
    8px
    0
    0;

  color: #ffffff;

  font-size: 9px;

  line-height: 1.5;
}


/* ============================================================
   CTA BUTTON
============================================================ */

.cta-button {
  width: 200px;

  min-width: 200px;

  height: 42px;

  flex-shrink: 0;

  padding:
    0
    14px
    0
    18px;

  background: var(--green);

  color: #111111;

  text-decoration: none;

  display: flex;

  align-items: center;

  justify-content: space-between;

  font-size: 10px;

  font-weight: 700;

  transition:
    background 0.2s ease,
    transform 0.2s ease;
}


.cta-button:hover {
  background: #8bd52b;

  transform: translateY(-1px);
}


/* ============================================================
   TABLET
============================================================ */

@media (max-width: 1050px) {

  .page-container {
    width: calc(100% - 60px);
  }


  .hero-left {
    width: 60%;
  }


  .hero-person {
    width: 48%;
  }


  .hero-title {
    font-size: 27px;
  }


  .hero-eyebrow {
    font-size: 23px;
  }


  .hero-text {
    width: 450px;
  }


  .cta-inner {
    gap: 18px;
  }


  .cta-shield {
    width: 105px;
    min-width: 105px;
  }


  .cta-button {
    width: 190px;
    min-width: 190px;
  }

}


/* ============================================================
   MOBILE
============================================================ */

@media (max-width: 760px) {

  .page-container {
    width: calc(100% - 36px);
  }


  /* ==========================================================
     HERO
  ========================================================== */

  .hero {
    height: auto;

    min-height: 980px;

    overflow: visible;
  }


  .hero-inner {
    height: auto;

    min-height: 980px;

    width: 100%;
  }


  .hero-background {
    width: 100%;

    height: 100%;

    object-fit: cover;

    object-position: center;
  }


  .hero-overlay {
    background:
      linear-gradient(
        180deg,
        rgba(5,5,5,0.15) 0%,
        rgba(5,5,5,0.60) 37%,
        rgba(5,5,5,0.97) 55%,
        rgba(5,5,5,1) 100%
      );
  }


  .hero-person {
    width: 100%;

    height: 410px;

    top: 0;

    right: 0;
  }


  .person-image {
    right: 0;

    width: 100%;

    height: 100%;

    object-position: bottom center;
  }


  .hero-left {
    width: 100%;

    height: auto;

    top: 365px;

    left: 0;

    padding:
      30px
      25px
      55px;
  }


  .hero-eyebrow {
    font-size: 20px;
  }


  .hero-title {
    font-size: 28px;

    max-width: 100%;
  }


  .hero-text {
    width: 100%;

    font-size: 11px;

    line-height: 1.7;

    margin-bottom: 28px;
  }


  /* ==========================================================
     HERO FEATURES MOBILE
  ========================================================== */

  .hero-features {
    width: 100%;

    max-width: 100%;

    margin-top: 28px;

    display: grid;

    grid-template-columns:
      1fr
      1fr;

    row-gap: 0;

    column-gap: 0;

    border: none !important;
  }


  .hero-feature {
    min-height: 175px;

    height: auto;

    padding:
      18px
      12px
      18px;

    display: flex;

    flex-direction: column;

    align-items: center;

    justify-content: flex-start;

    border: none !important;

    text-align: center;

    color: #ffffff;
  }


  .hero-feature:first-child {
    padding-left: 12px;

    border: none !important;
  }


  .hero-feature:last-child {
    border: none !important;
  }


  .hero-feature:nth-child(2n) {
    border: none !important;
  }


  .hero-feature:nth-child(3),
  .hero-feature:nth-child(4) {
    border: none !important;
  }


  /* ==========================================================
     ICON
  ========================================================== */

  .hero-feature-icon {
    height: 52px;

    margin-bottom: 12px;

    display: flex;

    align-items: center;

    justify-content: center;
  }


  .hero-feature-icon .v-icon {
    color: var(--green);

    font-size: 42px !important;
  }


  /* ==========================================================
     ÜBERSCHRIFT
  ========================================================== */

  .hero-feature-title {
    margin-bottom: 10px;

    color: #ffffff;

    font-size: 11px;

    line-height: 1.2;

    font-weight: 700;

    white-space: normal;
  }


  /* ==========================================================
     BESCHREIBUNG
  ========================================================== */

  .hero-feature-text {
    color: #ffffff;

    font-size: 10px;

    line-height: 1.55;

    max-width: 120px;
  }


  /* ==========================================================
     LEISTUNGEN
  ========================================================== */

  .services-section {
    padding-top: 38px;
  }


  .services-grid {
    grid-template-columns:
      1fr
      1fr;
  }


  .service-card {
    min-height: 175px;
  }


  /* ==========================================================
     BRANCHEN
  ========================================================== */

  .branches-grid {
    grid-template-columns:
      repeat(2, 1fr);

    row-gap: 20px;
  }


  .branch {
    min-height: 90px;
  }


  /* ==========================================================
     WARUM
  ========================================================== */

  .why-box {
    grid-template-columns: 1fr;

    row-gap: 20px;

    padding: 23px;
  }


  .why-divider {
    width: 100%;

    height: 1px;
  }


  .why-right {
    gap: 13px;
  }


  /* ==========================================================
     CTA
  ========================================================== */

  .cta-section {
    min-height: 0;

    height: auto;

    padding:
      28px
      0;
  }


  .cta-inner {
    min-height: 0;

    height: auto;

    flex-direction: column;

    align-items: flex-start;

    gap: 14px;

    padding: 0;
  }


  .cta-shield {
    display: none;
  }


  .cta-content {
    width: 100%;
  }


  .cta-content h2 {
    font-size: 25px;
  }


  .cta-content p {
    font-size: 10px;

    line-height: 1.6;
  }


  .cta-button {
    width: 100%;

    min-width: 0;

    height: 42px;
  }

}


/* ============================================================
   KLEINE HANDYS
============================================================ */

@media (max-width: 450px) {

  .services-grid {
    grid-template-columns: 1fr;
  }


  .hero {
    min-height: 1030px;
  }


  .hero-inner {
    min-height: 1030px;
  }


  .hero-title {
    font-size: 25px;
  }


  .hero-eyebrow {
    font-size: 18px;
  }


  .hero-person {
    height: 350px;
  }


  .hero-left {
    top: 315px;

    padding:
      28px
      18px
      55px;
  }


  .hero-text {
    font-size: 11px;

    line-height: 1.7;

    margin-bottom: 25px;
  }


  /* ==========================================================
     USP – SEHR KLEINE HANDYS
  ========================================================== */

  .hero-features {
    margin-top: 24px;

    width: 100%;

    border: none !important;
  }


  .hero-feature {
    min-height: 165px;

    height: auto;

    padding:
      16px
      10px;

    border: none !important;
  }


  .hero-feature:first-child,
  .hero-feature:last-child,
  .hero-feature:nth-child(2n),
  .hero-feature:nth-child(3),
  .hero-feature:nth-child(4) {
    border: none !important;
  }


  .hero-feature-icon {
    height: 48px;

    margin-bottom: 10px;
  }


  .hero-feature-icon .v-icon {
    font-size: 38px !important;
  }


  .hero-feature-title {
    font-size: 10px;

    line-height: 1.2;

    margin-bottom: 9px;
  }


  .hero-feature-text {
    font-size: 9px;

    line-height: 1.5;

    max-width: 115px;
  }


  .branches-grid {
    grid-template-columns: 1fr 1fr;
  }


  .section-heading p {
    font-size: 9px;
  }


  .service-card {
    min-height: 160px;
  }

}

</style>